"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentMetaDocumentStatusEnum = exports.DocumentMetaToJSON = exports.DocumentMetaFromJSONTyped = exports.DocumentMetaFromJSON = void 0;
const runtime_1 = require("../runtime");
function DocumentMetaFromJSON(json) {
    return DocumentMetaFromJSONTyped(json, false);
}
exports.DocumentMetaFromJSON = DocumentMetaFromJSON;
function DocumentMetaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'fileName': json['fileName'],
        'nameLinking': json['nameLinking'],
        'documentType': !runtime_1.exists(json, 'documentType') ? undefined : json['documentType'],
        'created': !runtime_1.exists(json, 'created') ? undefined : (new Date(json['created'])),
        'documentStatus': !runtime_1.exists(json, 'documentStatus') ? undefined : json['documentStatus'],
    };
}
exports.DocumentMetaFromJSONTyped = DocumentMetaFromJSONTyped;
function DocumentMetaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'fileName': value.fileName,
        'nameLinking': value.nameLinking,
        'documentType': value.documentType,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'documentStatus': value.documentStatus,
    };
}
exports.DocumentMetaToJSON = DocumentMetaToJSON;
/**
* @export
* @enum {string}
*/
var DocumentMetaDocumentStatusEnum;
(function (DocumentMetaDocumentStatusEnum) {
    DocumentMetaDocumentStatusEnum["PREAPPROVED"] = "PRE_APPROVED";
    DocumentMetaDocumentStatusEnum["APPROVED"] = "APPROVED";
    DocumentMetaDocumentStatusEnum["PENDING"] = "PENDING";
    DocumentMetaDocumentStatusEnum["REJECTED"] = "REJECTED";
    DocumentMetaDocumentStatusEnum["NOTREQUIRED"] = "NOT_REQUIRED";
    DocumentMetaDocumentStatusEnum["DELETED"] = "DELETED";
    DocumentMetaDocumentStatusEnum["INVALIDVALUE"] = "_INVALID_VALUE";
})(DocumentMetaDocumentStatusEnum = exports.DocumentMetaDocumentStatusEnum || (exports.DocumentMetaDocumentStatusEnum = {}));
//# sourceMappingURL=DocumentMeta.js.map